import React from 'react';
import { Accordion, Box, Typography } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import { LessonSection } from './LessonSection';
import DownloadReportButtonCommon, {
    DownloadReportButtonCommonProps
} from 'src/components/Reports/components/DownloadReportButtonCommon';

export type ReportType = 'EMPLOYEE_REPORT' | 'CHILD_REPORT';

interface LessonsSectionProps {
    title: string;
    generalCount: {
        groupCount: number;
        individualCount: number;
        totalCount: number;
    };
    lessonNamesToCount: Record<string, LessonCount>;
    reportType?: ReportType;
    startDate?: Date;
    endDate?: Date;
    employeeId?: string;
    childId?: string;
}

interface LessonCount {
    groupCount: number;
    individualCount: number;
    totalCount: number;
}

/**
 * Displays a section of lessons with their general and detailed counts
 */
export const LessonsSection: React.FC<LessonsSectionProps> = ({
    title,
    reportType,
    generalCount,
    lessonNamesToCount,
    startDate,
    endDate,
    employeeId,
    childId
}) => {
    const reportConfig: Record<ReportType, DownloadReportButtonCommonProps> = {
        EMPLOYEE_REPORT: { pageUrl: 'provided-services-act', params: { employeeId } },
        CHILD_REPORT: { pageUrl: 'child-report-act', params: { childId } }
    };

    const reportParams = reportType ? reportConfig[reportType] : null;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    padding: '1em 0'
                }}>
                <Box sx={{ flex: '1 1 50%' }}>
                    {title}
                    {reportParams && (
                        <DownloadReportButtonCommon
                            pageUrl={reportParams.pageUrl}
                            params={reportParams.params}
                            startDate={startDate}
                            endDate={endDate}
                            label="Завантажити акт"
                        />
                    )}
                </Box>
                <LessonSection countData={generalCount} />
            </Box>

            {lessonNamesToCount &&
                Object.entries(lessonNamesToCount).map(([lessonName, lessonData]) => {
                    return (
                        <Accordion
                            key={lessonName}
                            disableGutters
                            sx={{
                                boxShadow: 'none'
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    padding: '1em 0'
                                }}>
                                <ArrowRightIcon />
                                <Box sx={{ flex: '1 1 50%' }}>
                                    <Typography>{lessonName}</Typography>
                                </Box>
                                <LessonSection countData={lessonData} />
                            </Box>
                        </Accordion>
                    );
                })}
        </>
    );
};
